module.exports = __webpack_public_path__ + "static/media/spinner.d804dd4b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/media/spinner.svg
// module id = 1211
// module chunks = 0